import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance29buwn7hkq75x as Companion_getInstance,
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
} from '../LocalDateTime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocalDateTimeSerializerClass;
function LocalDateTimeSerializer() {
  if (LocalDateTimeSerializerClass === VOID) {
    class $ {
      constructor() {
        LocalDateTimeSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDateTime', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_getInstance().parse$default_rpbnp3_k$(decoder.decodeString_x3hxsx_k$());
      }
      serialize_o8xuc6_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_o8xuc6_k$(encoder, value instanceof LocalDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalDateTimeSerializer', VOID, VOID, [KSerializer()]);
    LocalDateTimeSerializerClass = $;
  }
  return LocalDateTimeSerializerClass;
}
var LocalDateTimeSerializer_instance;
function LocalDateTimeSerializer_getInstance() {
  if (LocalDateTimeSerializer_instance === VOID)
    new (LocalDateTimeSerializer())();
  return LocalDateTimeSerializer_instance;
}
//region block: exports
export {
  LocalDateTimeSerializer_getInstance as LocalDateTimeSerializer_getInstance30joe8yzqyv05,
};
//endregion

//# sourceMappingURL=LocalDateTimeSerializers.mjs.map
